import { createFileRoute } from "@tanstack/react-router";

import { ListDetailsPage as ListDetailsPageV2 } from "@/features/ListsV2/components/ListDetailsPage";

export const Route = createFileRoute("/_auth/people/$siteId/lists/$listId/")({
  component: ListDetailsRouteComponent,
});

function ListDetailsRouteComponent() {
  return <ListDetailsPageV2 />;
}
